export default {
    home: "首页",
    welcome: "欢迎",
    calendar: "日历",
    information: "新闻",
    dictionary: "词典",
    searchTerm: "请输入您的搜索词",
    search: "搜索",
    noSearchResults: "未找到搜索结果",
    writeAnArticle: "写文章",
    article: "文章",
    photo: "图片",
    publish: "发布",
    photoAlbum: "相册",
    logout: "注销",
    ubtzYouthAddress:"邮编, 210535，蒙古国、乌兰巴托市、巴彦郭勒区、首尔-42 街，乌兰巴托铁路局管理处",
    changeLanguage: "更改语言",
  };